module.exports = "/images/icon_01.png?7bd8306233e3c13d8d6479c87bd6260a";